import React from "react";
import { Container } from "@mui/material";
import WaveguideOrderList from "../components/WorkOrders/Waveguides/WaveguideOrderList";

export default function Waveguides(props) {
    const { user, token, handleOpenSnackbar, darkState } = props;

    return (
        <Container
            maxWidth="lg"
            sx={{
                py: { xs: 2, sm: 3, md: 4 },
            }}
        >
            <WaveguideOrderList
                handleOpenSnackbar={handleOpenSnackbar}
                darkState={darkState}
                user={user}
                token={token}
            />
        </Container>
    );
}
